import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Injectable, APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginModule } from './login/login.module';
import { LoaderCommonComponent } from './shared/loader/loader-common.component';
import { LoaderService } from './shared/loader/loader-service.service';
import { HttpLayerService } from './services/http-layer.service';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { SharedService } from './shared/shared.service';
import { AlertService } from './shared/alert.service';
import { SessionhandlerService } from './services/sessionhandler.service';
import { DataTablesModule } from 'angular-datatables';
import { AppService } from './app.service';
import { CommonComponentsModule } from './common-components/common-components.module';
import { GlobalVariablesService } from './layout/global-variables.service';
import { LayoutService } from './layout/layout.service';
import { Config } from './config/config';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

export function initApp(http: HttpClient, appService: AppService) {
    return () => {
        return http.get('assets/jsons/configuration/endPointConfig.json')
            .toPromise()
            .then((endPoints) => {
                if (endPoints['status'] && endPoints['data']['isJSONDriven']) {
                    const baseUrl = endPoints['data']['API'];
                    const tempObj = JSON.parse(JSON.stringify(Config.API));
                    const tempKeys = Object.keys(tempObj);
                    tempKeys.forEach(key => {
                        // const array = (tempObj[key]).split('/');
                        // if (array[array.length - 2] === 'api') {
                        //     tempObj[key] = baseUrl + 'api/' + (tempObj[key]).split('/').pop();
                        // } else {
                        tempObj[key] = baseUrl + (tempObj[key]).split('/').pop();
                        // }
                    });
                    Config.API = JSON.parse(JSON.stringify(tempObj));
                }
            });
    };
}
@Injectable()

@NgModule({
    declarations: [
        AppComponent,
        LoaderCommonComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        LoginModule,
        HttpClientModule,
        BrowserAnimationsModule,
        DataTablesModule,
        CommonComponentsModule,
        ReactiveFormsModule,
        FormsModule,
    ],
    exports: [LoaderCommonComponent],
    providers: [LoaderService,
        HttpLayerService,
        SharedService,
        AlertService,
        SessionhandlerService,
        AppService,
        GlobalVariablesService,
        LayoutService,
        {
            provide: APP_INITIALIZER,
            useFactory: initApp,
            multi: true,
            deps: [HttpClient]
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
